import { render, staticRenderFns } from "./AdminCreateAccount.vue?vue&type=template&id=03206d8e&"
import script from "./AdminCreateAccount.vue?vue&type=script&lang=ts&"
export * from "./AdminCreateAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports